import Form from 'antd/lib/form/Form';
import styled from 'styled-components';

export const Container = styled(Form)`
    .ant-form-item-label {
        font-size: 13px;
        font-weight: 400;
        padding: 0;
        margin-bottom: 5px;
        background-color: ${props => props.theme.colors.primary};
    }

    background-color: ${props => props.theme.colors.primary};

    label {
      display: block;
      width: 100%;
      white-space: nowrap; 
      overflow: hidden;
      text-overflow: ellipsis;
      color: ${props => props.theme.colors.textPrimary};

    }
`;